import React from "react";
import { ReactComponent as Slack } from "../helper/svgicon/socials/Slack.svg";
import { ReactComponent as Gmail } from "../helper/svgicon/socials/Gmail.svg";
import { ReactComponent as Instagram } from "../helper/svgicon/socials/Instagram.svg";
import style from "../sass/icons.module.scss";
const SocialConnect = () => {
     return (
          <div className={style.icons}>
               <a href="https://www.linkedin.com/in/richhapalchoudhary/" target="_blank" rel="noopener noreferrer">
                    <Slack />
               </a>
               <a href="mailto:richhapal10@hotmail.com" target="_blank">
                    <Gmail />
               </a>
               <a href="https://www.instagram.com/thenotoriousrich380/" target="_blank" rel="noopener noreferrer">
                    <Instagram />
               </a>
          </div>
     );
};
export default SocialConnect;
